export const translations = {
  en: {
    hero: {
      limitedTime: 'Limited Time Offer',
      spendCrypto: 'Spend Crypto',
      likeCash: 'Like Cash',
      registrationReward: 'Get up to $10 USDT for new registrations',
      playStore: 'Get it on Google Play',
    },
    features: {
      title: 'Blonix',
      subtitle: 'Crypto Card',
      description: 'Top up cryptocurrency with Blonix card. Spend anytime, anywhere.',
      virtualPhysical: {
        title: 'Virtual & Physical Cards',
        description: 'Available instantly on the app',
      },
      multiCrypto: {
        title: 'Multi-Crypto Support',
      },
      spendAnywhere: {
        title: 'Spend Anywhere',
        description: '90M+ merchants worldwide accept Blonix',
      },
    },
    steps: {
      title: 'Three Simple',
      subtitle: 'Steps',
      description: 'Get started with Blonix in under 5 minutes',
      step1: {
        title: 'Apply Card',
        description: 'Virtual or physical cards available on the app. Get started in minutes.',
      },
      step2: {
        title: 'Deposit Crypto',
        description: 'Fund your card with BTC, ETH, USDT, SOL and 10+ cryptocurrencies.',
      },
      step3: {
        title: 'Spend & Transfer',
        description: 'Use your crypto for everyday purchases and global transfers instantly.',
      },
    },
    cta: {
      title1: 'Register Now & Get up to',
      reward: '$10 USDT',
      description: 'Limited time offer for new users. Don\'t miss out!',
      button: 'Claim Your Reward',
    },
    footer: {
      privacy: 'Privacy',
      terms: 'Terms',
      support: 'Support',
      rights: '© 2026 Blonix. All rights reserved.',
      playStore: 'Available on Google Play',
    },
    signup: {
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      repeatPasswordPlaceholder: 'Repeat your password',
      referralPlaceholder: 'Referral code',
      termsText: 'By signing up, you agree to our',
      termsLink: 'Terms of Service',
      and: 'and',
      privacyLink: 'Privacy Policy',
      registerButton: 'Register',
      sendingOTP: 'Sending OTP...',
      otpSent: 'We\'ve sent a 6-digit OTP to',
      otpPlaceholder: 'Enter 6-digit OTP',
      backButton: 'Back',
      verifyButton: 'Verify & Register',
      registering: 'Registering...',
      resendOTP: 'Resend OTP',
      errors: {
        email: 'Please enter your email address',
        password: 'Please enter a password',
        passwordLength: 'Password must be at least 8 characters long',
        passwordMatch: 'Passwords do not match',
        terms: 'Please agree to the Terms of Service and Privacy Policy',
        otpInvalid: 'Please enter a valid 6-digit OTP',
        otpSentSuccess: 'OTP sent to your email. Please check your inbox.',
        registerSuccess: 'Registration successful! Welcome to Blonix!',
      },
    },
    badge: {
      text: 'Register now to get a change of',
      card: 'Virtual card',
    }
  },
  'zh-CN': {
    hero: {
      limitedTime: '限时优惠',
      spendCrypto: '使用加密货币',
      likeCash: '像现金一样',
      registrationReward: '新注册用户最高可获得 $10 USDT',
      playStore: '在 Google Play 上获取',
    },
    features: {
      title: 'Blonix',
      subtitle: '加密卡',
      description: '使用 Blonix 卡充值加密货币。随时随地消费。',
      virtualPhysical: {
        title: '虚拟卡和实体卡',
        description: '在 App 上立即获取',
      },
      multiCrypto: {
        title: '支持多种加密货币',
      },
      spendAnywhere: {
        title: '随处消费',
        description: '全球 9000 多万家商户接受 Blonix',
      },
    },
    steps: {
      title: '简单三个',
      subtitle: '步骤',
      description: '不到 5 分钟即可开始使用 Blonix',
      step1: {
        title: '申请卡片',
        description: 'App 提供虚拟卡或实体卡。几分钟内即可开始。',
      },
      step2: {
        title: '存入加密货币',
        description: '使用 BTC、ETH、USDT、SOL 和 10 多种加密货币为您的卡提供资金。',
      },
      step3: {
        title: '消费和转账',
        description: '立即使用您的加密货币进行日常购买和全球转账。',
      },
    },
    cta: {
      title1: '立即注册，最高可获得',
      reward: '$10 USDT',
      description: '新用户限时优惠。不要错过！',
      button: '领取您的奖励',
    },
    footer: {
      privacy: '隐私政策',
      terms: '服务条款',
      support: '客户支持',
      rights: '© 2026 Blonix。保留所有权利。',
      playStore: '在 Google Play 上获取',
    },
    signup: {
      emailPlaceholder: '输入您的电子邮件',
      passwordPlaceholder: '输入您的密码',
      repeatPasswordPlaceholder: '重复您的密码',
      referralPlaceholder: '邀请码',
      termsText: '注册即表示您同意我们的',
      termsLink: '服务条款',
      and: '和',
      privacyLink: '隐私政策',
      registerButton: '注册',
      sendingOTP: '正在发送验证码...',
      otpSent: '我们已向其发送了 6 位验证码',
      otpPlaceholder: '输入 6 位验证码',
      backButton: '返回',
      verifyButton: '验证并注册',
      registering: '正在注册...',
      resendOTP: '重新发送验证码',
      errors: {
        email: '请输入您的电子邮件地址',
        password: '请输入密码',
        passwordLength: '密码必须至少为 8 个字符',
        passwordMatch: '密码不匹配',
        terms: '请同意服务条款和隐私政策',
        otpInvalid: '请输入有效的 6 位验证码',
        otpSentSuccess: '验证码已发送到您的电子邮件。请检查您的收件箱。',
        registerSuccess: '注册成功！欢迎来到 Blonix！',
      },
    },
    badge: {
      text: '立即注册，有机会获得',
      card: '虚拟卡',
    }
  },
  'zh-TW': {
    hero: {
      limitedTime: '限時優惠',
      spendCrypto: '使用加密貨幣',
      likeCash: '像現金一樣',
      registrationReward: '新註冊用戶最高可獲得 $10 USDT',
      playStore: '在 Google Play 上獲取',
    },
    features: {
      title: 'Blonix',
      subtitle: '加密卡',
      description: '使用 Blonix 卡充值加密貨幣。隨時隨地消費。',
      virtualPhysical: {
        title: '虛擬卡和實體卡',
        description: '在 App 上立即獲取',
      },
      multiCrypto: {
        title: '支持多種加密貨幣',
      },
      spendAnywhere: {
        title: '隨處消費',
        description: '全球 9000 多萬家商戶接受 Blonix',
      },
    },
    steps: {
      title: '簡單三個',
      subtitle: '步驟',
      description: '不到 5 分鐘即可開始使用 Blonix',
      step1: {
        title: '申請卡片',
        description: 'App 提供虛擬卡或實體卡。幾分鐘內即可開始。',
      },
      step2: {
        title: '存入加密貨幣',
        description: '使用 BTC、ETH、USDT、SOL 和 10 多種加密貨幣為您的卡提供資金。',
      },
      step3: {
        title: '消費和轉賬',
        description: '立即使用您的加密貨幣進行日常購買和全球轉賬。',
      },
    },
    cta: {
      title1: '立即註冊，最高可獲得',
      reward: '$10 USDT',
      description: '新用戶限時優惠。不要錯過！',
      button: '領取您的獎勵',
    },
    footer: {
      privacy: '隱私政策',
      terms: '服務條款',
      support: '客戶支持',
      rights: '© 2026 Blonix。保留所有權利。',
      playStore: '在 Google Play 上獲取',
    },
    signup: {
      emailPlaceholder: '輸入您的電子郵件',
      passwordPlaceholder: '輸入您的密碼',
      repeatPasswordPlaceholder: '重複您的密碼',
      referralPlaceholder: '邀請碼',
      termsText: '註冊即表示您同意我們的',
      termsLink: '服務條款',
      and: '和',
      privacyLink: '隱私政策',
      registerButton: '註冊',
      sendingOTP: '正在發送驗證碼...',
      otpSent: '我們已向其發送了 6 位驗證碼',
      otpPlaceholder: '輸入 6 位驗證碼',
      backButton: '返回',
      verifyButton: '驗證並註冊',
      registering: '正在註冊...',
      resendOTP: '重新發送驗證碼',
      errors: {
        email: '請輸入您的電子郵件地址',
        password: '請輸入密碼',
        passwordLength: '密碼必須至少為 8 個字元',
        passwordMatch: '密碼不匹配',
        terms: '請同意服務條款和隱私政策',
        otpInvalid: '請輸入有效的 6 位驗證碼',
        otpSentSuccess: '驗證碼已發提到您的電子郵件。請檢查您的收件箱。',
        registerSuccess: '註冊成功！歡迎來到 Blonix！',
      },
    },
    badge: {
      text: '立即註冊，有機會獲得',
      card: '虛擬卡',
    }
  },
  es: {
    hero: {
      limitedTime: 'Oferta por Tiempo Limitado',
      spendCrypto: 'Usa Cripto',
      likeCash: 'Como Efectivo',
      registrationReward: 'Recibe hasta $10 USDT por nuevos registros',
      playStore: 'Consíguelo en Google Play',
    },
    features: {
      title: 'Blonix',
      subtitle: 'Tarjeta Cripto',
      description: 'Recarga criptomonedas con la tarjeta Blonix. Gasta en cualquier momento y lugar.',
      virtualPhysical: {
        title: 'Tarjetas Virtuales y Físicas',
        description: 'Disponible al instante en la app',
      },
      multiCrypto: {
        title: 'Soporte Multi-Cripto',
      },
      spendAnywhere: {
        title: 'Gasta en Cualquier Lugar',
        description: 'Más de 90M de comercios en todo el mundo aceptan Blonix',
      },
    },
    steps: {
      title: 'Tres Pasos',
      subtitle: 'Sencillos',
      description: 'Comienza con Blonix en menos de 5 minutos',
      step1: {
        title: 'Solicita tu Tarjeta',
        description: 'Tarjetas virtuales o físicas disponibles en la app. Empieza en minutos.',
      },
      step2: {
        title: 'Deposita Cripto',
        description: 'Recarga tu tarjeta con BTC, ETH, USDT, SOL y más de 10 criptomonedas.',
      },
      step3: {
        title: 'Gasta y Transfiere',
        description: 'Usa tu cripto para compras diarias y transferencias globales al instante.',
      },
    },
    cta: {
      title1: 'Regístrate Ahora y Obtén hasta',
      reward: '$10 USDT',
      description: 'Oferta por tiempo limitado para nuevos usuarios. ¡No te la pierdas!',
      button: 'Reclama tu Recompensa',
    },
    footer: {
      privacy: 'Privacidad',
      terms: 'Términos',
      support: 'Soporte',
      rights: '© 2026 Blonix. Todos los derechos reservados.',
      playStore: 'Disponible en Google Play',
    },
    signup: {
      emailPlaceholder: 'Introduce tu email',
      passwordPlaceholder: 'Introduce tu contraseña',
      repeatPasswordPlaceholder: 'Repite tu contraseña',
      referralPlaceholder: 'Código de referido',
      termsText: 'Al registrarte, aceptas nuestros',
      termsLink: 'Términos de Servicio',
      and: 'y',
      privacyLink: 'Política de Privacidad',
      registerButton: 'Registrarse',
      sendingOTP: 'Enviando OTP...',
      otpSent: 'Hemos enviado un OTP de 6 dígitos a',
      otpPlaceholder: 'Introduce el OTP de 6 dígitos',
      backButton: 'Atrás',
      verifyButton: 'Verificar y Registrarse',
      registering: 'Registrando...',
      resendOTP: 'Reenviar OTP',
      errors: {
        email: 'Por favor, introduce tu dirección de email',
        password: 'Por favor, introduce una contraseña',
        passwordLength: 'La contraseña debe tener al menos 8 caracteres',
        passwordMatch: 'Las contraseñas no coinciden',
        terms: 'Por favor, acepta los Términos de Servicio y la Política de Privacidad',
        otpInvalid: 'Por favor, introduce un OTP válido de 6 dígitos',
        otpSentSuccess: 'OTP enviado a tu email. Por favor, revisa tu bandeja de entrada.',
        registerSuccess: '¡Registro exitoso! ¡Bienvenido a Blonix!',
      },
    },
    badge: {
      text: 'Regístrate ahora para tener la oportunidad de obtener una',
      card: 'tarjeta virtual',
    }
  },
  pt: {
    hero: {
      limitedTime: 'Oferta por Tempo Limitado',
      spendCrypto: 'Use Cripto',
      likeCash: 'Como Dinheiro',
      registrationReward: 'Receba até $10 USDT para novos registros',
      playStore: 'Obtenha no Google Play',
    },
    features: {
      title: 'Blonix',
      subtitle: 'Cartão Cripto',
      description: 'Recarregue criptomoedas com o cartão Blonix. Gaste a qualquer hora, em qualquer lugar.',
      virtualPhysical: {
        title: 'Cartões Virtuais e Físicos',
        description: 'Disponível instantaneamente no app',
      },
      multiCrypto: {
        title: 'Suporte Multi-Cripto',
      },
      spendAnywhere: {
        title: 'Gaste em Qualquer Lugar',
        description: 'Mais de 90M de comerciantes em todo o mundo aceitam Blonix',
      },
    },
    steps: {
      title: 'Três Passos',
      subtitle: 'Simples',
      description: 'Comece com a Blonix em menos de 5 minutos',
      step1: {
        title: 'Peça seu Cartão',
        description: 'Cartões virtuais ou físicos disponíveis no app. Comece em minutos.',
      },
      step2: {
        title: 'Deposite Cripto',
        description: 'Abasteça seu cartão com BTC, ETH, USDT, SOL e mais de 10 criptomoedas.',
      },
      step3: {
        title: 'Gaste e Transfira',
        description: 'Use sua cripto para compras do dia a dia e transferências globais instantaneamente.',
      },
    },
    cta: {
      title1: 'Registe-se Agora e Ganhe até',
      reward: '$10 USDT',
      description: 'Oferta por tempo limitado para novos utilizadores. Não perca!',
      button: 'Reclame a Sua Recompensa',
    },
    footer: {
      privacy: 'Privacidade',
      terms: 'Termos',
      support: 'Suporte',
      rights: '© 2026 Blonix. Todos os direitos reservados.',
      playStore: 'Disponível no Google Play',
    },
    signup: {
      emailPlaceholder: 'Introduza o seu email',
      passwordPlaceholder: 'Introduza a sua senha',
      repeatPasswordPlaceholder: 'Repita a sua senha',
      referralPlaceholder: 'Código de referência',
      termsText: 'Ao registar-se, concorda com os nossos',
      termsLink: 'Termos de Serviço',
      and: 'e',
      privacyLink: 'Política de Privacidade',
      registerButton: 'Registar',
      sendingOTP: 'A enviar OTP...',
      otpSent: 'Enviámos um OTP de 6 dígitos para',
      otpPlaceholder: 'Introduza o OTP de 6 dígitos',
      backButton: 'Voltar',
      verifyButton: 'Verificar e Registar',
      registering: 'A registar...',
      resendOTP: 'Reenviar OTP',
      errors: {
        email: 'Por favor, introduza o seu endereço de email',
        password: 'Por favor, introduza uma senha',
        passwordLength: 'A senha deve ter pelo menos 8 caracteres',
        passwordMatch: 'As senhas não coincidem',
        terms: 'Por favor, concorde com os Termos de Serviço e a Política de Privacidade',
        otpInvalid: 'Por favor, introduza um OTP válido de 6 dígitos',
        otpSentSuccess: 'OTP enviado para o seu email. Por favor, verifique a sua caixa de entrada.',
        registerSuccess: 'Registo bem-sucedido! Bem-vindo à Blonix!',
      },
    },
    badge: {
      text: 'Registe-se agora para ter a oportunidade de obter um',
      card: 'cartão virtual',
    }
  },
  fr: {
    hero: {
      limitedTime: 'Offre à Durée Limitée',
      spendCrypto: 'Dépensez vos Cryptos',
      likeCash: 'Comme du Cash',
      registrationReward: 'Obtenez jusqu\'à 10$ USDT pour toute nouvelle inscription',
      playStore: 'Disponible sur Google Play',
    },
    features: {
      title: 'Blonix',
      subtitle: 'Carte Crypto',
      description: 'Rechargez en cryptomonnaies avec la carte Blonix. Dépensez n\'importe quand, n\'importe où.',
      virtualPhysical: {
        title: 'Cartes Virtuelles et Physiques',
        description: 'Disponible instantanément sur l\'application',
      },
      multiCrypto: {
        title: 'Support Multi-Crypto',
      },
      spendAnywhere: {
        title: 'Dépensez Partout',
        description: 'Plus de 90 millions de marchands acceptent Blonix dans le monde',
      },
    },
    steps: {
      title: 'Trois Étapes',
      subtitle: 'Simples',
      description: 'Commencez avec Blonix en moins de 5 minutes',
      step1: {
        title: 'Demandez votre Carte',
        description: 'Cartes virtuelles ou physiques disponibles sur l\'application. Commencez en quelques minutes.',
      },
      step2: {
        title: 'Déposez vos Cryptos',
        description: 'Approvisionnez votre carte avec BTC, ETH, USDT, SOL et plus de 10 cryptomonnaies.',
      },
      step3: {
        title: 'Dépensez et Transférez',
        description: 'Utilisez vos cryptos pour vos achats quotidiens et vos transferts mondiaux instantanément.',
      },
    },
    cta: {
      title1: 'Inscrivez-vous Maintenant et Recevez jusqu\'à',
      reward: '10$ USDT',
      description: 'Offre à durée limitée pour les nouveaux utilisateurs. Ne la manquez pas !',
      button: 'Réclamez Votre Récompense',
    },
    footer: {
      privacy: 'Confidentialité',
      terms: 'Conditions',
      support: 'Support',
      rights: '© 2026 Blonix. Tous droits réservés.',
      playStore: 'Disponible sur Google Play',
    },
    signup: {
      emailPlaceholder: 'Entrez votre email',
      passwordPlaceholder: 'Entrez votre mot de passe',
      repeatPasswordPlaceholder: 'Répétez votre mot de passe',
      referralPlaceholder: 'Code de parrainage',
      termsText: 'En vous inscrivant, vous acceptez nos',
      termsLink: 'Conditions d\'Utilisation',
      and: 'et notre',
      privacyLink: 'Politique de Confidentialité',
      registerButton: 'S\'inscrire',
      sendingOTP: 'Envoi de l\'OTP...',
      otpSent: 'Nous avons envoyé un OTP à 6 chiffres à',
      otpPlaceholder: 'Entrez l\'OTP à 6 chiffres',
      backButton: 'Retour',
      verifyButton: 'Vérifier et S\'inscrire',
      registering: 'Inscription...',
      resendOTP: 'Renvoyer l\'OTP',
      errors: {
        email: 'Veuillez entrer votre adresse email',
        password: 'Veuillez entrer un mot de passe',
        passwordLength: 'Le mot de passe doit contenir au moins 8 caractères',
        passwordMatch: 'Les mots de passe ne correspondent pas',
        terms: 'Veuillez accepter les Conditions d\'Utilisation et la Politique de Confidentialité',
        otpInvalid: 'Veuillez entrer un OTP valide à 6 chiffres',
        otpSentSuccess: 'OTP envoyé à votre email. Veuillez vérifier votre boîte de réception.',
        registerSuccess: 'Inscription réussie ! Bienvenue chez Blonix !',
      },
    },
    badge: {
      text: 'Inscrivez-vous maintenant pour tenter de gagner une',
      card: 'carte virtuelle',
    }
  },
};
